import watchCustomerAccount from './customerAccount'

export default watchCustomerAccount
